"use client"

import { cn } from "@/lib/utils"
import { HideSidebarIcon } from "@/src/shared/assets/icons"
import { useSidebarStore } from "@/stores/sidebar"

import { texts } from "./localization/texts"
import {
  sidebarIconClassName,
  sidebarItemClassName,
  sidebarItemCollapsedClassName
} from "./SidebarRow"

type SidebarCollapseProps = {
  isCollapsed: boolean
}

export function SidebarCollapse({ isCollapsed }: SidebarCollapseProps) {
  const collapse = useSidebarStore((state) => state.collapse)
  const expand = useSidebarStore((state) => state.expand)

  return (
    <button
      type="button"
      onClick={isCollapsed ? expand : collapse}
      aria-expanded={!isCollapsed}
      aria-controls="site-sidebar"
      aria-label={isCollapsed ? texts.showSidebar : texts.hideSidebar}
      title={isCollapsed ? texts.showSidebar : texts.hideSidebar}
      className={cn(
        sidebarItemClassName,
        "hover:text-white/80",
        isCollapsed && sidebarItemCollapsedClassName
      )}
    >
      <span className="flex size-6 shrink-0 items-center justify-center overflow-visible">
        <HideSidebarIcon
          className={cn(sidebarIconClassName, isCollapsed && "-scale-x-100")}
          width={24}
          height={24}
          aria-hidden
        />
      </span>
      {isCollapsed ? null : (
        <span className="min-w-0 flex-1 truncate text-left font-medium text-[12px]">
          {texts.hideSidebar}
        </span>
      )}
    </button>
  )
}
